import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const TituloCabeceraContext = createContext({ titulo: null, setTitulo: () => {} });

const TituloCabeceraProvider = ({ children = null }) => {
  const [titulo, setTitulo] = useState(null);
  const valor = useMemo(() => ({ titulo, setTitulo }), [titulo]);
  return <TituloCabeceraContext.Provider value={valor}>{children}</TituloCabeceraContext.Provider>;
};

TituloCabeceraProvider.propTypes = { children: PropTypes.node };

/** Lo que la pantalla muestra junto al botón del menú, en la barra superior. */
const useTituloCabecera = (texto, subtitulo) => {
  const { setTitulo } = useContext(TituloCabeceraContext);
  useEffect(() => {
    setTitulo({ texto, subtitulo });
    return () => setTitulo(null);
  }, [texto, subtitulo, setTitulo]);
};

const useLeerTituloCabecera = () => useContext(TituloCabeceraContext).titulo;

export { TituloCabeceraProvider, useTituloCabecera, useLeerTituloCabecera };
